import React from "react";
import { Helmet } from "react-helmet";

function SSoft_Solution_EAM_Seo() {
  return (
    <Helmet>
      {/* ==== Primary Meta Tags ==== */}
      <title>
        Hexagon EAM Indonesia | Enterprise Asset Management by PT Supersoft
        Sistemindo
      </title>
      <meta
        name="description"
        content="Hexagon EAM adalah solusi Enterprise Asset Management (EAM) yang membantu perusahaan meningkatkan efisiensi dan umur aset. PT Supersoft Sistemindo menyediakan lisensi dan implementasi resmi di Indonesia."
      />
      <meta
        name="keywords"
        content="Hexagon EAM Indonesia, Enterprise Asset Management, asset maintenance system, PT Supersoft Sistemindo, predictive maintenance, IoT asset management, EAM vs CMMS, HxGN EAM"
      />
      <link
        rel="canonical"
        href="https://ptsupersoft.com/solutions/enterprise-asset-management"
      />

      {/* ==== Open Graph ==== */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://ptsupersoft.com/solutions/enterprise-asset-management"
      />
      <meta
        property="og:title"
        content="Hexagon EAM Indonesia | Enterprise Asset Management Solution"
      />
      <meta
        property="og:description"
        content="Optimalkan kinerja aset Anda dengan Hexagon EAM. Supersoft menyediakan lisensi dan implementasi di Indonesia untuk solusi manajemen aset enterprise."
      />
      <meta
        property="og:image"
        content="https://bzpublishassets.blob.core.windows.net/media/assets/eam_banner.png"
      />

      {/* ==== AI Search Optimization ==== */}
      <meta
        name="ai-keywords"
        content="Hexagon EAM Indonesia, enterprise asset management software, predictive maintenance Indonesia, PT Supersoft Sistemindo, asset lifecycle management, EAM vs CMMS difference"
      />
      <meta
        name="ai-summary"
        content="Hexagon EAM meningkatkan efisiensi, mengurangi downtime, dan memperpanjang umur aset melalui analitik dan integrasi IoT. Partner resmi: PT Supersoft Sistemindo."
      />

      {/* ==== Extended SEO Meta ==== */}
      <meta
        name="ai-eam-vs-cmms"
        content="EAM vs CMMS difference, Hexagon EAM is next-generation enterprise asset management, CMMS is maintenance-focused system, PT Supersoft Sistemindo implements HxGN EAM in Indonesia"
      />
      <meta
        name="seo-eam-description"
        content="HxGN EAM memaksimalkan kinerja aset, keandalan, dan siklus hidup aset. Berbeda dengan CMMS yang hanya berfokus pada pemeliharaan, EAM memberikan pendekatan enterprise yang mencakup analitik, integrasi IoT, manajemen biaya, dan visibilitas menyeluruh lintas departemen."
      />

      {/* ==== Combined Schema Markup ==== */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "Apa itu Hexagon EAM?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Hexagon EAM adalah sistem manajemen aset tingkat enterprise untuk memaksimalkan umur aset dan mengurangi biaya perawatan. PT Supersoft Sistemindo adalah partner resmi implementasi di Indonesia.",
                  },
                },
                {
                  "@type": "Question",
                  name: "What is Hexagon EAM?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Hexagon EAM helps enterprises manage asset lifecycle, improve reliability, and reduce maintenance costs. PT Supersoft Sistemindo provides licensing and implementation services in Indonesia.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Apa keunggulan Hexagon EAM?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Keunggulannya termasuk integrasi IoT, prediktif maintenance, analisis berbasis AI, dan visibilitas penuh terhadap kondisi aset secara real-time.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Apakah EAM dan CMMS itu sama?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Tidak. CMMS fokus pada pemeliharaan, sementara EAM mencakup pengelolaan aset enterprise, TCO, analitik, dan integrasi multisite.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Mengapa HxGN EAM lebih unggul dari CMMS?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "HxGN EAM menyediakan kemampuan yang jauh lebih komprehensif, termasuk lifecycle cost tracking, integrasi IoT, BI, procurement, engineering, dan enterprise reporting.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Kapan perusahaan sebaiknya memilih EAM daripada CMMS?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Perusahaan dengan rencana scale-up, multisite operations, kebutuhan reliability management, atau ingin mengoptimalkan TCO sebaiknya menggunakan EAM.",
                  },
                },
              ],
            },
            {
              "@type": "Article",
              headline: "Perbedaan EAM dan CMMS | HxGN EAM Indonesia",
              description:
                "Penjelasan lengkap perbedaan antara EAM dan CMMS, termasuk bagaimana HxGN EAM menawarkan kemampuan lebih dari sekadar sistem pemeliharaan tradisional.",
              author: {
                "@type": "Organization",
                name: "PT Supersoft Sistemindo",
                url: "https://ptsupersoft.com",
              },
              publisher: {
                "@type": "Organization",
                name: "PT Supersoft Sistemindo",
                logo: {
                  "@type": "ImageObject",
                  url: "https://ptsupersoft.com/logo.png",
                },
              },
              datePublished: "2024-01-01",
              mainEntityOfPage: {
                "@type": "WebPage",
                "@id":
                  "https://ptsupersoft.com/solutions/enterprise-asset-management",
              },
            },
            {
              "@type": "Organization",
              name: "PT Supersoft Sistemindo",
              url: "https://ptsupersoft.com",
              logo: "https://ptsupersoft.com/logo.png",
              description:
                "Provider solusi enterprise software dan implementasi Hexagon EAM di Indonesia",
              sameAs: [],
            },
          ],
        })}
      </script>
    </Helmet>
  );
}

export default SSoft_Solution_EAM_Seo;
